import * as React from 'react';
import { twMerge } from 'tailwind-merge';
const PulsingCircleIconComponent = ({
  className,
  circleClassName,
}: {
  className: string;
  circleClassName?: string;
}) => (
  <span className={twMerge('relative flex', className)}>
    <span
      className={twMerge(
        'absolute inline-flex h-full w-full animate-ping rounded-full bg-product2-purple-400 opacity-75',
        circleClassName,
      )}
    ></span>
    <span
      className={twMerge(
        'relative inline-flex h-full w-full rounded-full bg-product2-purple-400',
        circleClassName,
      )}
    ></span>
  </span>
);
export default PulsingCircleIconComponent;
